import { initializeApp } from "firebase/app";
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
} from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const isEmulator = !!process.env.REACT_APP_AUTH_EMULATOR_HOST;
const getFirebaseConfig = () => {
  if (isEmulator) {
    // Minimal config for emulator
    return {
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID, // Your emulator project ID
      apiKey: "demo-key", // Dummy value
      authDomain: "localhost",
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    };
  } else {
    // Production config
    return {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    };
  }
};

const app = initializeApp(getFirebaseConfig());
export const auth = getAuth(app);
export const storage = getStorage(app);

// Configure Google OAuth provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});

// Add required scopes
googleProvider.addScope("email");
googleProvider.addScope("profile");

// Connect to emulator in development
if (isEmulator && process.env.REACT_APP_AUTH_EMULATOR_HOST) {
  connectAuthEmulator(auth, process.env.REACT_APP_AUTH_EMULATOR_HOST);
}

if (isEmulator && process.env.REACT_APP_STORAGE_EMULATOR_HOST) {
  const [host, port] = process.env.REACT_APP_STORAGE_EMULATOR_HOST.split(":");
  connectStorageEmulator(storage, host, parseInt(port));
}
